import { createAction } from '@reduxjs/toolkit';
import type { ColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';
import type { SpreadsheetDataEntityFilterState } from '~/store/spreadsheetData/filtering/useSpreadsheetDataEntityFilters';
import type { WeightedCenterState } from './weightedCenter.state';

export const weightedCenterSetSelectedEntities = createAction(
  'WEIGHTED_CENTER_SET_SELECTED_ENTITIES',
  (newSelectedEntities: Partial<SpreadsheetDataEntityFilterState>) => ({ payload: { newSelectedEntities } })
);

export const weightedCenterClearSelectedEntities = createAction(
  'WEIGHTED_CENTER_CLEAR_SELECTED_ENTITIES'
);

export const weightedCenterSetResults = createAction(
  'WEIGHTED_CENTER_SET_RESULTS',
  (params: Readonly<{
    data: WeightedCenterState['results']['data'];
    center: WeightedCenterState['results']['weightedCenter'];
  }>) => ({ payload: params })
);

export const weightedCenterOnResultsError = createAction(
  'WEIGHTED_CENTER_ON_RESULTS_ERROR',
);

export const weightedCenterSetWeightColumnId = createAction(
  'WEIGHTED_CENTER_SET_WEIGHT_COLUMN_ID',
  (weightColumnId: ColumnId | null) => ({ payload: { weightColumnId } })
);
